module.exports = __webpack_public_path__ + "img/global.12f670a1.png";